module.exports = __webpack_public_path__ + "static/media/light-motion-deorbiting.34f7845.mp4";